import { createContext, ReactNode, use } from 'react';

import { useVisitor } from '../hooks/useVisitor';

import { useIsCheckingAuth } from './AuthContext';
import { useConsent, useConsentGiven } from './ConsentContext';

interface VisitorContextValue {
    visitorId: string | null;
    audiences: string[] | null;
}

export const VisitorContext = createContext<VisitorContextValue>({
    visitorId: null,
    audiences: null,
});

export function useVisitorContext(): VisitorContextValue {
    const context = use(VisitorContext);
    return context;
}

export function useVisitorId() {
    const { visitorId } = useVisitorContext();
    return visitorId;
}

export function useVisitorAudiences() {
    const { audiences = null } = useVisitorContext();
    return audiences;
}

interface VisitorContextProviderProps {
    children?: ReactNode;
    disabled?: boolean;
}

export function VisitorContextProvider({
    children = null,
    disabled = false,
}: VisitorContextProviderProps) {
    const hasConsent = useConsent('analytics_storage');
    const consentGiven = useConsentGiven();
    const isCheckingAuth = useIsCheckingAuth();
    const { visitorId = null, audiences = null } = useVisitor({
        enabled: hasConsent && !isCheckingAuth && !disabled,
    });

    const value = {
        visitorId: consentGiven ? visitorId : null,
        audiences,
    };

    return <VisitorContext value={value}>{children}</VisitorContext>;
}
